import { render } from "./post-smtp-ads.vue?vue&type=template&id=2975379f&scoped=true"
import script from "./post-smtp-ads.vue?vue&type=script&lang=js"
export * from "./post-smtp-ads.vue?vue&type=script&lang=js"

import "./post-smtp-ads.vue?vue&type=style&index=0&id=2975379f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2975379f"]])

export default __exports__